module.exports = __webpack_public_path__ + "static/img/萌唐唐诗会1.bf48a08a.png";